import { useRef, useEffect } from 'react';
import { EditorView, lineNumbers } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import { python } from '@codemirror/lang-python';
import { oneDark } from '@codemirror/theme-one-dark';
import { quietlight } from '@uiw/codemirror-themes-all';
import { useTheme } from '../context/ThemeContext';

const autoHeightTheme = EditorView.theme({
  '&': { height: 'auto' },
  '.cm-scroller': { overflow: 'hidden' },
  '.cm-content, .cm-gutter': { minHeight: 'auto' },
});

/**
 * Блок Python в условиях (markdown): нумерация строк слева и подсветка синтаксиса.
 */
export default function MarkdownPythonCodeBlock({ code = '' }) {
  const hostRef = useRef(null);
  const { theme } = useTheme();

  useEffect(() => {
    const parent = hostRef.current;
    if (!parent) return undefined;
    const themeExt = theme === 'dark' ? oneDark : quietlight;

    const state = EditorState.create({
      doc: code,
      extensions: [
        python(),
        themeExt,
        lineNumbers(),
        autoHeightTheme,
        EditorView.editable.of(false),
        EditorState.readOnly.of(true),
        EditorView.lineWrapping,
        EditorView.theme({
          '.cm-scroller': {
            fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
            fontSize: '0.9rem',
            lineHeight: '1.45',
          },
        }),
      ],
    });

    const view = new EditorView({ state, parent });
    return () => {
      view.destroy();
    };
  }, [code, theme]);

  return <div ref={hostRef} className="markdown-python-code-block" />;
}
